import { devtools } from 'zustand/middleware';
import SheetAttributeManager from 'services/sheet-attribute-manager/SheetAttributeManager';
import { create, registerZustandStoreReset } from 'store/create';
import { AttributeMapperStore } from './types';
import { ClearAttributeMappingsPayload } from '../../services/sheet-attribute-manager/models/sheet-attribute-manager.interface';

const useAttributeMapperStore = create<AttributeMapperStore>()(
  devtools(
    (set, get) => ({
      attributeMapperManager: new SheetAttributeManager({
        data: {},
        sheetIndicatorMapping: [],
      }),
      getAttributeMapperManager: () => get().attributeMapperManager,
      setAttributeMapperManager: manager => set(() => ({ attributeMapperManager: manager })),
      clearAttributeMapperManager: (docRefPayload?: ClearAttributeMappingsPayload) => {
        const currentManager = get().attributeMapperManager;
        if (docRefPayload) {
          const newManager = currentManager?.handleClearMappings(docRefPayload);
          if (newManager) {
            return set(() => ({ attributeMapperManager: new SheetAttributeManager(newManager.sheetAttributeMapping) }));
          }
        }

        return set(() => ({
          attributeMapperManager: new SheetAttributeManager({
            data: {},
            sheetIndicatorMapping: [],
          }),
        }));
      },
    }),
    {
      name: 'AttributeMapperStore',
    }
  )
);

registerZustandStoreReset(useAttributeMapperStore, () => {
  useAttributeMapperStore.setState({
    attributeMapperManager: new SheetAttributeManager({
      data: {},
      sheetIndicatorMapping: [],
    }),
  });
});

export default useAttributeMapperStore;
